import React from 'react'
import { FormattedMessage } from 'react-intl'
import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import RestoreIcon from '@mui/icons-material/Undo'

import messages from '../../shared/messages'

const StyledRestoreIcon = styled(RestoreIcon)(({ theme }) => ({
  marginRight: theme.spacing(1)
}))

const RestoreButton = ({ ...buttonProps }) => (
  <Button color="primary" {...buttonProps}>
    <StyledRestoreIcon />
    <FormattedMessage id={messages.restore.id} />
  </Button>
)

export default RestoreButton
